<template>
  <!-- コンポーネントをレンダリング -->
  <component
    v-if="initialized"
    :is="componentIs"
    :key="`col:${colName}__${keyUpdatedAt}`"
    :ref="`col:${colName}`"
    :colName="colName"
    :value="ModelFormService.$modelFormVueInstance.data[colName]"
    :record="ModelFormService.$modelFormVueInstance.data"
    :recordRoot="ModelFormService.$modelFormVueInstance.data"
    :ModelFormService="ModelFormService"
    :modelName="ModelFormService.modelName"
    :readOnlyMode="ModelFormService.readOnlyMode"
    :passedColDefinition="col"
    :virtualModelName="ModelFormService.virtualModelName"
    :validation="true"
    :hideColNameLabel="true"
    :disableAutoOrdering="true"
    v-bind="$attrs"
    @update:value-and-error="
      ($event) => {
        ModelFormService.$modelFormVueInstance.editCallback(
          ModelFormService.$modelFormVueInstance.data,
          colName,
          $event.value,
          ModelFormService.$modelFormVueInstance.data[colName],
          $event.error,
          $event.modelInputVm,
        )
      }
    "
  />
</template>

<script lang="ts">
import { defineComponent, inject, PropType } from 'vue'
import { ColumnDef } from '../../types'
import { ModelFormService } from './ModelFormService'
import { registerComposableComponentSettings } from '../../plugins/ComposableComponents'

registerComposableComponentSettings('ModelFormColumn', {
  name: 'ModelFormColumn',
  // hasDefaultSlot: false,
  label: 'ModelFormColumn',
  configColumns: {
    colName: {
      label: 'colName',
      type: 'STRING',
      defaultValue: '',
    },
    // columnDefOverride: {
    //   label: 'columnDefOverride',
    //   type: 'OBJECT',
    //   defaultValue: {},
    // },
    columnDefOverrideResolveFunctionDef: {
      label: 'カラム定義の上書き設定(関数)',
      type: 'TEXT',
      inputComponent: 'CodeEditor',
      defaultValue: '',
      inputAttrs: {
        initCode: (callerVueInstance) => {
          return `return async ({colName, originalColDef, vueInstance}) => {
  /** @type {ColumnDefPartial<any>} */
  const columnDefOverride = {}
  return columnDefOverride
}`
        }
      },
      inputHelpText:
        'カラム定義を上書きするための関数を指定できます。引数は、colName, columnDefOverride です。',
    },
  },
  description: `ModelForm のカラムを定義するコンポーネントです。`,
})

const fixedResetColDef = {
  groupKey: ''
}
export default {
  name: 'ModelFormColumn',
  props: {
    colName: {
      type: String,
      required: true,
    },
    columnDefOverride: {
      type: Object as PropType<Partial<ColumnDef>>,
      default: () => ({}),
    },
    columnDefOverrideResolveFunctionDef: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      initialized: false,
      resolvedColumnDefOverride: {},
      keyUpdatedAt: Date.now(),
    }
  },
  watch: {
    columnDefOverrideResolveFunctionDef: {
      async handler() {
        await this.resolveColDef()
        this.keyUpdatedAt = Date.now()
      },
      immediate: false,
    },
    columnDefOverride: {
      handler() {
        this.keyUpdatedAt = Date.now()
      },
      immediate: false,
    },
  },
  async mounted() {
    // resolve
    this.initStates()
  },
  inject: {
    ModelFormService: {
      from: 'ModelFormServiceInstance',
      default: null as ModelFormService
    },
  },
  computed: {
    originalColDef() {
      return this.ModelFormService?.targetColumns?.[this.colName] || {
        name: this.colName,
        type: 'STRING', // fallback value
      }
    },
    col() {
      return Object.assign(
        {},
        this.originalColDef,
        fixedResetColDef,
        this.columnDefOverride,
        this.resolvedColumnDefOverride || {},
      )
    },
    componentIs() {
      if (this.col.isExtraComponent) {
        return {
          ...this.col,
        }
      }
      return 'ModelFormGroup'
    },
  },
  methods: {
    async initStates() {
      this.initialized = false
      await this.resolveColDef()
      this.$nextTick(() => {
        this.initialized = true
      })
    },
    async resolveColDef() {
      if (this.columnDefOverrideResolveFunctionDef) {
        try {
          const argValues = {
            colName: this.colName,
            originalColDef: this.originalColDef,
            vueInstance: this,
          }
          const resolveFunction = await $core.$utils.executeStringDefinedFunction({
            functionString: this.columnDefOverrideResolveFunctionDef,
            functionArgValues: argValues,
          })
          if(typeof resolveFunction === 'function') {
            this.resolvedColumnDefOverride = await resolveFunction(argValues)
          } else if (typeof resolveFunction === 'object') {
            this.resolvedColumnDefOverride = resolveFunction
          } else {
            console.warn(
              `ModelFormColumn: columnDefOverrideResolveFunction must return an object or a function that returns an object. Received: ${typeof resolveFunction}`, {resolveFunctionResult: resolveFunction},
            )
            this.resolvedColumnDefOverride = {}
          }
        } catch (e) {
          this.resolvedColumnDefOverride = {} // reset
        }
      } else {
        this.resolvedColumnDefOverride = {} // reset
      }
    }
  }
}
</script>
